import { useTranslation } from 'react-i18next'
import { CopyButton } from '@/components/portal/CopyButton'
import { ComingSoonBadge } from '@/components/portal/ComingSoonBadge'
import { AppDownloadBadges } from '@/components/portal/AppDownloadBadges'
import { formatIdrRate } from '@/lib/format-idr-rate'
import { cn } from '@/lib/utils'

interface AccountCardProps {
  kind: 'live' | 'demo'
  loginId: string
  /** Live rows whose MT5 login is still being issued ("pending-…"). */
  pending?: boolean
  typeLabel: string
  status?: 'active' | 'inactive' | null
  rate?: number | null
  leverage?: string | null
}

export function AccountCard({ kind, loginId, pending = false, typeLabel, status, rate, leverage }: AccountCardProps) {
  const { t } = useTranslation()
  const statusLabel =
    status === 'inactive' ? t('home.statusInactive') : status === 'active' ? t('home.statusActive') : null

  return (
    <article className={cn('prod-acct', `prod-acct--${kind}`)}>
      <div className="prod-acct__top">
        <span className="prod-acct__type">{typeLabel}</span>
        {statusLabel ? (
          <span className={`prod-acct__status prod-acct__status--${status}`}>{statusLabel}</span>
        ) : null}
      </div>

      <div className="prod-acct__login">
        <span className="prod-acct__login-label">{t('home.loginLabel')}</span>
        {pending ? (
          <span className="prod-acct__login-id prod-acct__login-id--pending">{t('home.livePending')}</span>
        ) : (
          <div className="prod-acct__login-row">
            <span className="prod-acct__login-id">{loginId}</span>
            <CopyButton value={loginId} label={t('home.loginCopyLabel', { id: loginId })} />
          </div>
        )}
      </div>

      {rate != null || leverage ? (
        <dl className="prod-acct__meta">
          {rate != null ? (
            <div>
              <dt>{t('home.rateLabel')}</dt>
              <dd>{formatIdrRate(rate)}</dd>
            </div>
          ) : null}
          {leverage ? (
            <div>
              <dt>{t('home.leverageLabel')}</dt>
              <dd>{leverage}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}

      <div className="prod-acct__apps">
        <div className="prod-acct__apps-head">
          <span className="prod-acct__apps-title">{t('home.tradeOnMt5')}</span>
          <ComingSoonBadge />
        </div>
        <AppDownloadBadges />
      </div>
    </article>
  )
}
